<template>
    <header class="app-header" :class="{'video-header' : this.$route.name == 'Video', 'video-not-full' : isFullscreen == true, 'showHeader':headerSession, 'isLoading' : isLoading}">
        <resources-navigation v-bind:VideoData="VideoData" v-if="headerSession"></resources-navigation>
        <div class="logos">
            <img class="logo logo-1" src="../../assets/logo.png" alt="Young Enterprise" width="250">
            <img class="logo logo-2" src="../../assets/mmw.png" alt="My Money Week" width="140">
        </div>
        <div class="container" v-if="headerSession === false">
        <div class="account_menu account-home" >
            <div class="language_buttons">
                <button  class="btn btn-icon" :class="{ 'active' : this.isActiveEn  }" @click="setNewLanguage('en')">
                English
                </button>
                <button  class="btn btn-icon" :class="{ 'active' : this.isActiveCy }" @click="setNewLanguage('cy')">
                Cymraeg
                </button>
            </div>
        </div>
       </div>
    </header>
</template>
<script>

    import { mapState, mapMutations } from 'vuex';
    import VideoNavigation from './VideoNavigation.vue';
    import ResourcesNavigation from './ResourcesNavigation.vue';

    export default {
        name: 'Header',
        props: ['VideoData', 'ResourcesData', 'headerSession', 'isLoading'],
        components:{
            VideoNavigation,
            ResourcesNavigation,
        },
        computed: mapState([
         // map this.school to store.state.school etc.
         'isFullscreen',
        ]),
        data() {
        return {
            language: null,
            isActiveEn: null,
            isActiveCy: null,
            }
        },
        created(){
             const urlParams = new URLSearchParams(window.location.search);
             const language = urlParams.get("language");

            this.setAppTextLanguage();
             
            if(language != null) {

             // Set default to English
             if(language !== 'en' && language !== 'cy') {
                this.setLanguage('en'); 
                document.documentElement.lang = 'en'; 
             }
             else {
                this.setLanguage(language); 
                document.documentElement.lang = language; 
             }
            }

            this.language = this.$store.getters.getLanguage;

            if (this.language == 'en') {
                this.isActiveEn = true;
            }
            else {
                this.isActiveCy = true;
            }
        },
         methods: {
             ...mapMutations({
                setLanguage: 'setLanguage',
                setAppTextLanguage: 'setAppTextLanguage'
             }),
            setNewLanguage(language="")
            {       
                this.setLanguage(language);
                this.$store.state.language = language;
                document.documentElement.lang = language;
            },
         },
         watch: {
            '$store.state.language': function () {
                this.language = this.$store.getters.getLanguage;

                if (this.language == 'en') {
                    this.isActiveEn = true;
                    this.isActiveCy = false;
                }
                else {
                    this.isActiveCy = true;
                    this.isActiveEn = false;
                }
            },
        }
    }
</script>

<!-- "scoped" attribute limits CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/global/AppHeader.vue